// extracted by mini-css-extract-plugin
module.exports = {"BoldPlayer":"_3euJ3","boldPlayer":"_3euJ3","mediaButton":"_2eQhC","icon":"_191zP","pausing":"_2L47k","playing":"lDl23"};